// components/Header.js

function Header(){
    return (
        <header className="portfolio-header">
            <h1>Developer Portfolio</h1>
            <div className="header-decoration"></div>
        </header>
    );
}
export default Header;